module.exports = __webpack_public_path__ + "static/logo-32b2b15e8a23051990968c71f3a93452.png";